import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'speciesImageUrl',
  pure: false
})
export class SpeciesImageUrlPipe implements PipeTransform {

  constructor() {}

  transform(species?: string): string {
    if (species) {
      const splitSpecies = species.split('/Uploads/');

      if (splitSpecies?.[0] === "") {
        return environment.apiUrl + '/Uploads/' + splitSpecies[1]
      }
      else {
        return species
      }
    }
    return ''
  }
}
